import { useQuery } from '@tanstack/react-query';
import { settingsService } from '@/lib/services/settings';

export const useRewardsSystem = () => {
  // Check if rewards system is enabled at the store level (Settings model).
  // isEnabled is derived from THIS query, so its loading state is what callers
  // must wait on — otherwise a fresh refresh (uncached settings) looks like
  // "disabled" before settings have even loaded, firing a false toast/redirect.
  //
  // Deliberately does NOT fetch /api/rewards/admin/settings: this hook is
  // mounted globally (Layout), and that endpoint 403s for anyone below the
  // store's adminAccessLevel. Admin components that need RewardSettings
  // fetch it themselves (RewardSystemSettings, UserAllocationsManager).
  const { data: storeSettings, isLoading: storeSettingsLoading } = useQuery({
    queryKey: ['settings'],
    queryFn: settingsService.getSettings,
    staleTime: 5 * 60 * 1000, // 5 minutes
  });

  return {
    isEnabled: storeSettings?.rewardsConfig?.enabled ?? false, // Default to disabled if not set
    // Loading until the store-level settings (which determine isEnabled) resolve.
    isLoading: storeSettingsLoading,
  };
};
